import { useEffect, useState } from 'react';
import useVideoContext from './useVideoContext';
import { useTwilioAppState } from '../state/';

export default function useRoomState() {
  const { room } = useVideoContext();
  const [state, setState] = useState('disconnected');
  const { _isMounted } = useTwilioAppState();
    useEffect(() => {
        if (_isMounted && _isMounted.current === true) {           
            const setRoomState = () => setState(room && room.state ? room.state : 'disconnected');
           
            setRoomState();
            if (room) {
                room
                    .on('disconnected', setRoomState)
                    .on('reconnected', setRoomState)
                    .on('reconnecting', setRoomState);
            }
            
            return () => {
                if (room) {
                    room
                        .off('disconnected', setRoomState)
                        .off('reconnected', setRoomState)
                        .off('reconnecting', setRoomState);
                }               
            };
        }
    }, [room, _isMounted]);

  return state;
}
